module.exports = __webpack_public_path__ + "img/logo-shiba8881.1d7b82f7.png";